<template>
  <v-card class="border-none rounded-lg px-3 shadow-sm card-reward" no-body>
    <div class="rounded-lg p-3 overflow-hidden contant-reward">
      <div class="text-center">
        <b class="f-xl" data-lang="win_reward">{{ $t("win_reward") }}</b>

        <div class="text-gray mt-2">
          <small>
            <template v-if="!mission"
              >{{
                getRewardList[count] && getRewardList[count].redeem_code
              }}
              :</template
            >
            <span class="text-success">
              <font-awesome-icon
                icon="check-circle"
                class="mx-1 text-success"
              />
              <span data-lang="received_prize">{{ $t("received_prize") }}</span>
            </span>
          </small>
        </div>
      </div>
      <!-- <lottie-player
        autoplay
        :loop="true"
        mode="normal"
        background="transparent"
        direction="1"
        class="box-animation"
        src="https://lottie.host/1776e287-8136-49e3-bf99-296c592ad298/gMmOqfbV9c.json"
        style="width: 100%; height: 100%"
      ></lottie-player> -->
      <div class="opened-box">
        <c-img
          :src="require('@/assets/images/opened-box.gif')"
          @error="handleImageSrc"
          class="image-reward"
        ></c-img>
      </div>

      <p
        class="text-center mt-3 f-md"
        id="previewMessage"
        data-lang="received_prize_description"
      >
        {{ $t("received_prize_description") }}
      </p>
      <div class="text-center">
        <c-btn
          pill
          variant="confirm-primary"
          class="shadow-box mb-2 mt-0 btn-open-box"
          @click="$emit('next')"
          data-test="step3-next-btn"
        >
          {{
            mission ? $t("view_mission_prize") : $t("view_random_reward_prize")
          }}
        </c-btn>
        <div style="height: 24px"></div>
      </div>
    </div>
  </v-card>
</template>

<script>
require("@lottiefiles/lottie-player");

export default {
  props: {
    countList: { required: true },
    getRewardList: { required: true },
    count: { required: true },
    mission: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    rewardImage(items) {
      if (items) {
        if (items.random_reward_item_type == 4)
          return require("@/assets/images/point.png");
        if (items.random_reward_item_type == 1)
          return require("@/assets/images/Fail.png");
        if (items.item_img) return items.item_img;
        return require("@/assets/images/default-image.png");
      }
      return require("@/assets/images/default-image.png");
    }
  }
};
</script>
<style lang="scss">
.opened-box {
  background: whitesmoke;
  border-radius: 0.5rem;
  transition: all 1s;
  text-align: center;
  // img {
  //   max-width: 200px;
  // }
}
</style>
